import { twMerge } from 'tailwind-merge';

export default function Divider({ className }: { className?: string }) {
  return (
    <hr
      data-component="corso-divider"
      className={twMerge('border-outline-variant', className)}
    />
  );
}
